/*
 === FAQ Expand/Collapse ===
   Jaco: 2025-07-25
*/
document.addEventListener("DOMContentLoaded", function () {
  const questions = document.querySelectorAll(".faq-page-question");

  questions.forEach((q) => {
    const header = q.querySelector(".faq-page-question-header");

    if (header) {
      header.addEventListener("click", function () {
        q.classList.toggle("active");
      });
    }
  });
});
